import * as React from 'react';
import {connect} from 'react-redux';
import * as VehiclesModule from 'Modules/VehiclesModule';
import * as ReportModule from 'Modules/ReportModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {withTranslation} from 'react-i18next';
import {ParentDetails, CustomProps, IParentDetailsProps} from 'components/Layout/DetailsSidebar/ParentDetails';
import CarMainReport from './../Form/CarMainReportForm';
import {createSerachQuery} from 'Connectors/_main';

interface IP extends IParentDetailsProps {
    history: any;
}

type ConnectedP = {
    vehiclesStore: VehiclesModule.Types.VehiclesStore;
    reportStore: ReportModule.Types.ReportStore;
};
type DispatchedP = {
    setDetailsForVehile: (car: VehiclesModule.Types.CarDto) => void;
    getCarMainReport: (params: URLSearchParams) => void;
    getReportFile: (extension: ReportModule.EnumTypes.ReportExtension, type: ReportModule.EnumTypes.ReportType, params?: URLSearchParams) => void;
    showVehicleList: () => void;
    t?: (key: string) => string;
};
type S = {};

class CarMainReportDetails extends ParentDetails<IP & ConnectedP & DispatchedP, S> {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public getCustomProps(): CustomProps {
        return {
            ...(this.props as any),
            extrnalRender: () => this.extrnalRender()
        };
    }

    private async handleSubmit(formData: any) {
        const query = {...formData};
        const {getCarMainReport} = this.getCustomProps();
        query.car_id = query.car_id.id;
        const params = createSerachQuery(query);
        await getCarMainReport(params);
    }

    public async componentWillUnMount() {
        await this.props.setDetailsForVehile(null);
    }

    private extrnalRender() {
        const {vehiclesStore, setDetailsForVehile, getReportFile, reportStore, t, showVehicleList} = this.getCustomProps();
        const {PDF, CSV, XLSX} = ReportModule.EnumTypes.ReportExtension;
        const {MAIN_CAR_REPORT} = ReportModule.EnumTypes.ReportType;
        return (
            <>
                <CarMainReport
                    onSubmit={this.handleSubmit}
                    initialValues={{car_id: vehiclesStore.activeVehicleDetails}}
                    {...{onCarRemoval: () => setDetailsForVehile(null), onListOpen: () => showVehicleList()}}
                />
                <div className="report__generate-file">
                    <button disabled={reportStore.carMainReport === null} className="report__button btn btn--clean"
                            onClick={() => getReportFile(PDF, MAIN_CAR_REPORT)}>
                        <img src={'/images/icons/pdf_icon.svg'} alt="PDF" className="report__button-img"/>
                        <span>{t('exportToPDF')}</span>
                    </button>
                    <button disabled={reportStore.carMainReport === null} className="report__button btn btn--clean"
                            onClick={() => getReportFile(CSV, MAIN_CAR_REPORT)}>
                        <img src={'/images/icons/csv_icon.svg'} alt="CSV" className="report__button-img"/>
                        <span>{t('exportToCSV')}</span>
                    </button>
                    <button disabled={reportStore.carMainReport === null} className="report__button btn btn--clean"
                            onClick={() => getReportFile(XLSX, MAIN_CAR_REPORT)}>
                        <img src={'/images/icons/xls_icon.svg'} alt="XLS" className="report__button-img"/>
                        <span>{t('exportToXLS')}</span>
                    </button>
                </div>
            </>
        );
    }
}

function mapStateToProps(state: any): ConnectedP {
    return {
        vehiclesStore: state.vehiclesStore,
        reportStore: state.reportStore
    };
}

function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        setDetailsForVehile: (car: VehiclesModule.Types.CarDto) => dispatch(VehiclesModule.Actions.setDetailsForVehile(car)),
        getCarMainReport: (params: URLSearchParams) => dispatch(ReportModule.Actions.getCarMainReport(params)),
        getReportFile: (extension: ReportModule.EnumTypes.ReportExtension, type: ReportModule.EnumTypes.ReportType, params?: URLSearchParams) =>
            dispatch(ReportModule.Actions.getReportFile(extension, type, params)),
        showVehicleList: () => dispatch(ViewManagementModule.Actions.showVehicleList())
    };
}

export default withTranslation('reports')(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(CarMainReportDetails) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/CarMainReportDetails.tsx